export const stateName = 'itemUpload';
export const REQUEST_DELAY = 500;
export const WITHOUT_BRAND_ID = 1; // Should match Brand::ID_EMPTY (from backend)

export const NUMBER_OF_IMAGES_PER_ITEM = 20;
export let BookDetailStatus;

(function (BookDetailStatus) {
  BookDetailStatus["Found"] = "found";
  BookDetailStatus["NotFound"] = "not found";
})(BookDetailStatus || (BookDetailStatus = {}));

export let IsbnValidity;

(function (IsbnValidity) {
  IsbnValidity["Unvalidated"] = "unvalidated";
  IsbnValidity["Valid"] = "valid";
  IsbnValidity["Invalid"] = "invalid";
})(IsbnValidity || (IsbnValidity = {}));

export let FieldName;

(function (FieldName) {
  FieldName["Unisex"] = "unisex";
  FieldName["Title"] = "title";
  FieldName["Size"] = "size_id";
  FieldName["Brand"] = "brand_id";
  FieldName["Status"] = "status_id";
  FieldName["Description"] = "description";
  FieldName["Price"] = "price";
  FieldName["PackageSize"] = "package_size_id";
  FieldName["DomesticShipmentPrice"] = "shipment_prices.domestic";
  FieldName["InternationalShipmentPrice"] = "shipment_prices.international";
  FieldName["Catalog"] = "catalog_id";
  FieldName["Color"] = "color";
  FieldName["Photos"] = "photos";
  FieldName["Isbn"] = "isbn";
  FieldName["Material"] = "material_id";
  FieldName["VideoGameRating"] = "video_game_rating_id";
  FieldName["ShippingFromLocation"] = "shipping_from_location";
  FieldName["ShippingSettingsNearby"] = "nearby_carriers";
  FieldName["ShippingSettingsDistant"] = "distant_carriers";
  FieldName["ShippingSettingsUnknownDistance"] = "unknown_distance_carriers";
  FieldName["ShippingMethod"] = "shipping_method";
  FieldName["Bump"] = "bump";
  FieldName["MeasurementWidth"] = "measurement_width";
  FieldName["MeasurementLength"] = "measurement_length";
})(FieldName || (FieldName = {}));

export let FieldTrackingName;

(function (FieldTrackingName) {
  FieldTrackingName["Isbn"] = "isbn";
  FieldTrackingName["Price"] = "price";
  FieldTrackingName["Photo"] = "photo";
  FieldTrackingName["Material"] = "material";
  FieldTrackingName["VideoGameRating"] = "video_game_rating";
  FieldTrackingName["Title"] = "title";
  FieldTrackingName["Catalog"] = "catalog";
  FieldTrackingName["Color"] = "color";
  FieldTrackingName["Description"] = "description";
  FieldTrackingName["Brand"] = "brand";
  FieldTrackingName["Size"] = "size";
  FieldTrackingName["Condition"] = "condition";
  FieldTrackingName["Category"] = "category";
  FieldTrackingName["CategoryUnisex"] = "category_unisex";
  FieldTrackingName["PackageSize"] = "package_size";
  FieldTrackingName["Bump"] = "bump";
  FieldTrackingName["MeasurementShoulderWidth"] = "measurement_shoulder_width";
  FieldTrackingName["MeasurementLength"] = "measurement_length";
})(FieldTrackingName || (FieldTrackingName = {}));

export let ItemUploadFailReason;

(function (ItemUploadFailReason) {
  ItemUploadFailReason["ValidationError"] = "validation_error";
  ItemUploadFailReason["ServerError"] = "server_error";
  ItemUploadFailReason["Other"] = "other";
})(ItemUploadFailReason || (ItemUploadFailReason = {}));

export let SupportedDynamicAttributes;

(function (SupportedDynamicAttributes) {
  SupportedDynamicAttributes["Material"] = "material";
})(SupportedDynamicAttributes || (SupportedDynamicAttributes = {}));

export let CatalogGroupFieldCodes;

(function (CatalogGroupFieldCodes) {
  CatalogGroupFieldCodes["Unisex"] = "unisex";
  CatalogGroupFieldCodes["Isbn"] = "isbn";
  CatalogGroupFieldCodes["Author"] = "author";
  CatalogGroupFieldCodes["BookTitle"] = "book_title";
  CatalogGroupFieldCodes["Brand"] = "brand";
  CatalogGroupFieldCodes["VideoGameRating"] = "video_game_rating";
  CatalogGroupFieldCodes["Size"] = "size";
  CatalogGroupFieldCodes["Measurements"] = "measurements";
  CatalogGroupFieldCodes["Status"] = "status";
  CatalogGroupFieldCodes["Color"] = "color";
  CatalogGroupFieldCodes["Material"] = "material";
})(CatalogGroupFieldCodes || (CatalogGroupFieldCodes = {}));